import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=028baa3c&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=js&"
export * from "./NavBar.vue?vue&type=script&lang=js&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=028baa3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028baa3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028baa3c')) {
      api.createRecord('028baa3c', component.options)
    } else {
      api.reload('028baa3c', component.options)
    }
    module.hot.accept("./NavBar.vue?vue&type=template&id=028baa3c&scoped=true&", function () {
      api.rerender('028baa3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/EscolhaPerfil/components/NavBar.vue"
export default component.exports